import ArtifactGroupType from "../base/ArtifactGroupType";


const WeaponsOfValhalla = {
  id: '117',
  name: 'Weapons Of Valhalla',
  groupIcon: 'EchoesOfTheNorth',
  type: ArtifactGroupType.ECHOES_OF_THE_NORTH,
  icon: 'WeaponsOfValhalla',
  power: 10,
  gameId: 'WeaponsOfValhalla'
};

export default WeaponsOfValhalla;
